import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Config } from '../_store';
import { UtilityService } from './utility.service';
import { CommonService } from './common.service';
import { StorageService } from './storage.service';
import { StringConstants } from '../_constants/stringConstants';
import { OfflineService } from './offlineService';
import { AppConfigService } from './appConfigService';
import { CommonDataService } from '../appDataServices/commonDataService';
import { Router } from '@angular/router';
import { AppStateService } from './state.service';
import { RouteNavigationService } from './routeNavigationService';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<any>;
    public currentUser: Observable<any>;

    private _currentUserVal;

    private lastActivityTime;

    private forgotPinMode = false;
    private userSessionTimedOut = false;

    appSettingsData: any = {};

    private tempData = {
        virtualAccntDetails: {
            dataObj: {}
        }
    }

    public invalidAttemptsGlobal: number = 0;

    constructor(
        private utilityService: UtilityService,
        private commonService: CommonService,
        private storageService: StorageService,
        private offlineService: OfflineService,
        private appConfigService: AppConfigService,
        private commonDataService: CommonDataService,
        private router: Router,
        private routeNavService: RouteNavigationService,
        private appStateService: AppStateService
    ) {
        this.initUserData();
    }

    getUserDataInSession() {
        return this.storageService.get(StringConstants.USER_sessionStr);
    }

    public initUserData() {
        this.getUserDataInSession().then(val => {
            this._currentUserVal = JSON.parse(val);
            this.setUserObservable(this._currentUserVal);
        });
    }

    private setUserObservable(userData) {
        this.currentUserSubject = new BehaviorSubject<any>(userData);
        this.currentUser = this.currentUserSubject.asObservable();
    }

    private setUserDataToSessionStorage(userData) {
        this.storageService.add(StringConstants.USER_sessionStr, JSON.stringify(userData));
    }

    public get currentUserValue(): any {
        return this.currentUserSubject && this.currentUserSubject.value;
    }

    getOTP(phoneNo: string) {
        const deviceId = this.commonService.deviceId();
        const loginMode = this.appStateService.getStaticState('loginMode') || {};
        const req = {
            username: phoneNo,
            deviceId: deviceId,
            isRtp: loginMode.isRTPLink
        };
        return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('GETOTP'))
            .pipe(map(data => {
                return data.data || data;
            }));
    }

    login(username: string, password: string, isPinLogin = true) {
        const deviceId = this.commonService.deviceId();
        const loginMode = this.appStateService.getStaticState('loginMode') || {};
        const req = {
            username: username,
            password: isPinLogin ? password : undefined,
            deviceId: deviceId,
            otp: isPinLogin ? undefined : password,
            isRtp: loginMode.isRTPLink
        };
        const url = Config.dashboardServiceEndpoints.LOGIN
        return this.utilityService.httpPost(req, url)
            .pipe(map(data => {
                const loginData = data.data || data;
                if (!loginData.session) {
                    throw new Error(data.msg);
                } else {
                    this.processUserLogin(loginData);
                    return loginData;
                }
            }));
    }

    // TODO
    // Refactor function 
    processUserLogin(loginData) {
        console.log('login data');
        console.log(loginData);

        const deviceId = this.commonService.deviceId();
        const userProfileData = loginData.user || {};
        const userRoleName = userProfileData.userRole || 'Buyer';
        const userRole = this.appConfigService.roleNamesMapping[userRoleName] || '1';
        const username = (loginData.user.eippSession || {}).username;
        let userData: any = {
            loginData: loginData,
            session: loginData.session,
            eippSession: loginData.user.eippSession || loginData.session,
            userId: username,
            userName: userProfileData.displayName || 'PayEX User',
            device_id: deviceId,
            loggedInTimeStamp: this.commonService.getCurrentTimeStamp(),
            userRole: userRole,
            roleData: this.appConfigService.rolesData[userRole],
            appLogo: userProfileData.appLogo,
            uiConfig: userProfileData.uiConfig,
            localeUIConfig: userProfileData.localeUIConfig
        };
        console.log(userData);
        
        userData.isVelvoline = loginData.user.sellerCode === 'Valvoline' ? true : false;
        if (loginData.user && loginData.user.eippSessionData.data.user.forcePinChange) {
            userData.forcePinChange = true;
        }
        setTimeout(() => {
            this.commonDataService.getSellers({
                session: loginData.session
            }).subscribe(sellersResponse => {
                const sellers = sellersResponse.sellers || [];
                this.utilityService.httpPost({
                    session: userData.session,
                    action: Config.webActions.GET_BUYER_OPTIONS,
                    sellerCodes: (sellers).map(val => (val.sellerCode as string).toLowerCase()),
                }, this.commonService.getInterfaceUrl('GET_BUYER_OPTIONS')).subscribe(value => {
                    if (value.status === true) {
                        console.log();
                        
                        // Object.assign(userData, value.data,{reqToRecon:true});
                        Object.assign(userData, value.data,{reqToRecon:loginData.user.eippSessionData.data.user.enableRTR});

                        setTimeout(() => {
                            this.commonDataService.getSellers({
                                session: loginData.session
                            }).subscribe(sellersResponse => {
                                this.utilityService.httpPost({
                                    session: userData.session,
                                    action: Config.webActions.GET_BUYER_OPTIONS,
                                    sellerCodes: (sellersResponse.sellers || []).map(val => (val.sellerCode as string).toLowerCase()),
                                }, this.commonService.getInterfaceUrl('GET_BUYER_OPTIONS')).subscribe(value => {
                                    if (value.status === true) {
                                        console.log("value true");
                                        
                                        Object.assign(userData, value.data,{reqToRecon:loginData.user.eippSessionData.data.user.enableRTR});

                                        this.setUserDataToSessionStorage(userData);
                                        this.setUserLoggedInWithOTP();
                                        this.currentUserSubject.next(userData);
                                        this.appStateService.clearStaticState('loginMode')
                                        console.log(userData);
                                        
                                    }
                                });
                            })

                        }, 1000)
                        this.setUserDataToSessionStorage(userData);
                        this.setUserLoggedInWithOTP();
                        this.currentUserSubject.next(userData);
                    }
                });
                const isINROnlySeller = sellers.filter(seller => seller.currCode === 'INR').length === sellers.length;
                userData.canManagePayMethods = !isINROnlySeller;
                this.setUIConfigOnUserData(sellers?.length ? sellers[0].sellerCode : '', userData);
            })
        }, 1000)
        this.setUserDataToSessionStorage(userData);
        // console.log(userData);
        this.setUserLoggedInWithOTP();
        this.currentUserSubject.next(userData);

    }

    private setUIConfigOnUserData(sellerCode, userData) {
        this.commonDataService.getUIConfigBySellerCode(sellerCode).subscribe(data => {
            Object.assign(userData, { uiConfig: data.data });
            this.setUserDataToSessionStorage(userData);
            this.currentUserSubject.next(userData);
        });
    }

    getToken(phoneNo: string, otp: string = '1234') {
        const req = {
            imei: this.commonService.imei(),
            auth_mobile: phoneNo,
            otp: otp,
            action: Config.webActions.GETTOKEN,
            device_id: this.commonService.deviceId()
        };
        return this.utilityService.httpPost(req, this.appConfigService.urls.authUrl)
            .pipe(map(user => {
                if (!user.data || !user.data.token) {
                    user.data = {
                        token: {
                            accessToken: '123'
                        }
                    };
                }
                return user.data;
            }));
    }

    changePassword(req) {
        return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('CHANGE_PASSWORD')).pipe(map(data => {
            if (data && (data.status || data.success)) {
                this.resetForcePinChangeFlag();
            }
            return data;
        }));
    }

    getAppVersion() {
        return this.utilityService.httpPost({
            appId: (Config.appName || '').toLowerCase()
        }, this.commonService.getInterfaceUrl('GET_APP_VERSION')).pipe(map(data => {
            return data.data;
        }));
    }

    logout(forcedLogout = false) {
        // remove user from local storage to log user out
        this.storageService.remove([
            StringConstants.IMEI_sessionStr,
            StringConstants.DEVICEID_sessionStr,
            StringConstants.USER_sessionStr,
            StringConstants.INVOICE_multipayGroupStr,
            StringConstants.SUPPORTED_Languages
        ]);
        this.offlineService.clearOfflineData();
        this.lastActivityTime = undefined;
        if (!forcedLogout) {
            this.userSessionTimedOut = false;
        }
        this.currentUserSubject.next(null);
    }

    private setUserLoggedInWithOTP() {
        this.storageService.add(StringConstants.USER_loggedInWithOTP, '1');
    }

    getUserAcceptedTerms() {
        return this.storageService.get(StringConstants.USER_ACCEPTED_TERMS_CONDITIONS);
    }

    setUserAcceptedTerms() {
        return this.storageService.add(StringConstants.USER_ACCEPTED_TERMS_CONDITIONS, 1);
    }

    getUserLoggedInWithOTP() {
        return this.storageService.get(StringConstants.USER_loggedInWithOTP);
    }

    setForgotpinMode(setVal) {
        this.forgotPinMode = setVal;
    }

    getForogotpinMode() {
        return this.forgotPinMode;
    }

    checkLastActivityTime(forcedLogout = false) {
        const currentTime = this.commonService.getCurrentTimeStamp();
        if (this.lastActivityTime || forcedLogout) {
            const diff = currentTime - this.lastActivityTime;
            const timeoutVal = this.commonService.isCurrentPlatformWeb() ? Config.sessionTimeout.web : Config.sessionTimeout.device;
            if (diff >= timeoutVal || forcedLogout) {
                this.userSessionTimedOut = true;
                this.logout(true);
                setTimeout(() => {
                    this.userSessionTimedOut = false;
                });
                return true;
            }
        }
        this.lastActivityTime = this.commonService.getCurrentTimeStamp();
    }

    setLastActivityTime() {
        this.lastActivityTime = this.commonService.getCurrentTimeStamp();
    }

    getIsUserSessionTimedout() {
        if (this.userSessionTimedOut) {
            return true;
        } else {
            return false;
        }
    }

    updateMenuItems(options: any) {
        let userData = this.currentUserValue;
        if (options && typeof options.isRieterRetailer !== 'undefined') {
            userData.isRieterRetailer = options.isRieterRetailer;
        }
        this.setUserDataToSessionStorage(userData);
        this.currentUserSubject.next(userData);
    }

    resetForcePinChangeFlag() {
        let userData = this.currentUserValue;
        console.log('user data');
        console.log(userData);

        userData.loginData.user.eippSessionData.data.user.forcePinChange = undefined;
        this.setUserDataToSessionStorage(userData);
        this.currentUserSubject.next(userData);
    }

    getVirtualAccntDetails() {
        const req = Object.assign({}, this.tempData.virtualAccntDetails.dataObj);
        return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('VIRTUAL_DETAILS'))
            .pipe(map(data => {
                return Object.assign({}, data.data || data, req);
            }));
    }

    isCurrentUserSalesman() {
        const currentUser = this.currentUserValue;
        return currentUser && currentUser.userRole && currentUser.userRole == '2';
    }



    getUserName() {
        const userData = this.currentUserValue;
        return userData.userName || userData.userCPGCode || '';
    }

    async setInvalidLoginAttemptWithPIN() {
        const currentInvalidAttempts = await this.getInvalidLoginAttemptWithPIN();
        this.storageService.add(StringConstants.USER_INVALID_LOGINATTEMPTS, ((currentInvalidAttempts || 0) + 1));
    }

    getUserID() {
        const userData = this.currentUserValue;
        return userData.userId;
    }

    setOpenVirtualAccntDetails(val) {
        this.tempData.virtualAccntDetails.dataObj = val;
    }

    async getInvalidLoginAttemptWithPIN() {
        return await this.storageService.get(StringConstants.USER_INVALID_LOGINATTEMPTS);
    }

    async clearInvalidLoginAttemptsWithPIN() {
        await this.storageService.remove([StringConstants.USER_INVALID_LOGINATTEMPTS]);
    }
}
